'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIDialogButton;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decorators = require('../utils/propTypes/decorators');

var _renderProp = require('../utils/propTypes/renderProp');

var RenderProp = _interopRequireWildcard(_renderProp);

var _iconName = require('../utils/propTypes/iconName');

var _Color = require('../core/Color');

var _HoverProvider = require('../providers/HoverProvider');

var _HoverProvider2 = _interopRequireDefault(_HoverProvider);

var _Styles = require('../utils/Styles');

var _colors = require('HubStyleTokens/colors');

var _sizes = require('HubStyleTokens/sizes');

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UIIconHolder = require('../icon/UIIconHolder');

var _UIIconHolder2 = _interopRequireDefault(_UIIconHolder);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DialogButton = (0, _styledComponents2.default)(function (_ref) {
  var __hovered = _ref.hovered,
      rest = _objectWithoutProperties(_ref, ['hovered']);

  return _react2.default.createElement(_UIClickable2.default, rest);
}).attrs({ className: 'private-modal__control' }).withConfig({
  displayName: 'UIDialogButton__DialogButton'
})(['', ';align-items:center;color:', ';display:flex;flex-shrink:0;justify-content:center;height:', ';line-height:normal;position:relative;width:', ';z-index:', ';&::after{', ';background:', ';border-radius:100%;content:\' \';left:50%;padding:20px;position:absolute;top:50%;transform:translate(-50%,-50%);}&[aria-disabled=\'true\']{cursor:not-allowed;opacity:0.6;}'], (0, _Styles.setUiTransition)('color'), _colors.OLAF, _sizes.MODAL_CLOSE_BUTTON_SIZE, _sizes.MODAL_CLOSE_BUTTON_SIZE, _sizes.MERCURY_LAYER, (0, _Styles.setUiTransition)('background'), function (props) {
  return props.hovered && (0, _Color.rgba)(_colors.OLAF, 0.1);
});

// fix for IE11 misaligning icons when using UIIconHolder:
// https://git.hubteam.com/HubSpot/UIComponents/issues/5105
var ICON_STYLES = {
  marginLeft: 'auto',
  marginRight: 'auto'
};

function UIDialogButton(props) {
  var IconHolder = props.IconHolder,
      iconName = props.iconName,
      iconSize = props.iconSize,
      rest = _objectWithoutProperties(props, ['IconHolder', 'iconName', 'iconSize']);

  return _react2.default.createElement(
    _HoverProvider2.default,
    props,
    function (hoverProviderProps) {
      return _react2.default.createElement(
        DialogButton,
        _extends({}, rest, hoverProviderProps),
        _react2.default.createElement(IconHolder, {
          innerStyles: ICON_STYLES,
          name: iconName,
          padding: 0,
          size: iconSize
        })
      );
    }
  );
}

UIDialogButton.propTypes = {
  'aria-label': _propTypes2.default.string.isRequired,
  hovered: (0, _decorators.hidden)(_propTypes2.default.bool),
  IconHolder: RenderProp.getPropType(_UIIconHolder2.default),
  iconName: (0, _iconName.getIconNamePropType)(),
  iconSize: _UIIconHolder2.default.propTypes.size
};

UIDialogButton.defaultProps = {
  IconHolder: _UIIconHolder2.default,
  iconSize: 'xxs'
};

UIDialogButton.displayName = 'UIDialogButton';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/UIDialogButton.js
// module id = 474
// module chunks = 177